import { render, staticRenderFns } from "./HistoryTopUpWalletToShop.vue?vue&type=template&id=5c0adc22&"
import script from "./HistoryTopUpWalletToShop.vue?vue&type=script&lang=js&"
export * from "./HistoryTopUpWalletToShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports